export const CATERING_CATEGORIES = {
  BUFFET: 'buffet',
  BENTOS: 'bentos',
  MINI_BENTO: 'mini-bento',
  CANAPES: 'canapes',
} as const;

export const LABEL_BY_CATEGORY = {
  [CATERING_CATEGORIES.BUFFET]: 'Buffet Menu',
  [CATERING_CATEGORIES.BENTOS]: 'Warm Bento',
  [CATERING_CATEGORIES.MINI_BENTO]: 'Mini Bento',
  [CATERING_CATEGORIES.CANAPES]: 'Canapés',
};

export const WORKDAYS_TO_ADD = 3;

export const DEFAULT_SLOT_TIME_OPTION = {
  label: 'Select Time',
  value: '',
};

export const SLOT_TIMES = [
  {
    label: '08:00 AM',
    value: '08:00',
  },
  {
    label: '08:30 AM',
    value: '08:30',
  },
  {
    label: '09:00 AM',
    value: '09:00',
  },
  {
    label: '09:30 AM',
    value: '09:30',
  },
  {
    label: '10:00 AM',
    value: '10:00',
  },
  {
    label: '10:30 AM',
    value: '10:30',
  },
  {
    label: '11:00 AM',
    value: '11:00',
  },
  {
    label: '11:30 AM',
    value: '11:30',
  },
  {
    label: '12:00 PM',
    value: '12:00',
  },
  {
    label: '12:30 PM',
    value: '12:30',
  },
  {
    label: '01:00 PM',
    value: '13:00',
  },
  {
    label: '01:30 PM',
    value: '13:30',
  },
  {
    label: '02:00 PM',
    value: '14:00',
  },
  {
    label: '02:30 PM',
    value: '14:30',
  },
  {
    label: '03:00 PM',
    value: '15:00',
  },
  {
    label: '03:30 PM',
    value: '15:30',
  },
  {
    label: '04:00 PM',
    value: '16:00',
  },
  {
    label: '04:30 PM',
    value: '16:30',
  },
  {
    label: '05:00 PM',
    value: '17:00',
  },
  {
    label: '05:30 PM',
    value: '17:30',
  },
  {
    label: '06:00 PM',
    value: '18:00',
  },
  {
    label: '06:30 PM',
    value: '18:30',
  },
  {
    label: '07:00 PM',
    value: '19:00',
  },
];

export const GST_RATE = 0.09;

export const MINIMUM_ORDER_AMOUNT = 100;

export const LABOUR_FEE_PER_FLOOR = 85;

export const DELIVERY_AGREEMENT = `I agree that my contact details are complete & correct and delivery personnel will be given lift-access to my doorstep. I agree to bear a labour fee of $${LABOUR_FEE_PER_FLOOR} per floor the logistics personnel has to climb in order to deliver or setup my catering order. For food safety reasons, I agree that if delivery fails, my order will be forfeited.`;

export const POSTAL_CODE_REGEX = /^\d{6}$/;

export const CATERING_PURCHASE_GA4_EVENT_KEY =
  'catering_order_success';
